export default __webpack_public_path__ + "static/pilot-flying-j-truck-care-3b21052b83dc9c5c5b56aa720aeea7e8.png";